

export default function useEnv() {

  return {
    apiUrl: process.env.VUE_APP_API_URL,
  }

}

